import _ from 'lodash';
import { Scenario } from 'types/pricingSimulator';
import { getPercentageChangeV2 } from 'utils/helperMethods';

const rankDictionary: any = {
    1234567890: 'Hilo',
    1234567891: 'EDLP',
    1234567892: 'Maintain',
    1234567893: 'Conservative',
    1234567894: 'Aggressive',
    1234567895: 'Improve Margin',
    1234567896: 'Moderate',
};

export const scenarioDetailsParser = (
    data: any[],
    selectedScenarioInfo: Scenario,
    isDropdownAtLowestLevel: boolean,
    isViewMode: Function,
) => {
    try {
        //creating an object with kpi id as key
        const attributeInputOutputMapping: any = {};

        //uncomment this during integration with real data
        selectedScenarioInfo?.activeLense?.activeLenseData?.attributes
            ?.filter((item) => {
                return item.isSelected;
            })
            .forEach((item: any) => {
                attributeInputOutputMapping[item.attributeId] = {
                    isEditable: item.isEditable,
                    allowedDecimals: item?.allowedDecimals,
                    label: item?.name,
                    pre: item?.pre,
                    post: item?.post,
                    iconType: item?.iconType,
                };
            });

        const result = data?.map((item: any, index: number) => {
            const kpiObject: any = {};
            item?.kpis?.map((kpi: any) => {
                const rankValue = rankDictionary?.[kpi?.new];
                if (kpi?.id in attributeInputOutputMapping) {
                    const kpiItem = attributeInputOutputMapping[kpi?.id];
                    const isEditable = !isViewMode() && kpiItem?.['isEditable'];
                    const inputValue = rankValue ? undefined : isEditable ? kpi?.new : undefined;
                    const outputValue = rankValue ? undefined : !isEditable ? kpi?.new : undefined;
                    const displayValue = rankValue ?? kpi?.value ?? undefined;
                    const leftValue = outputValue ?? inputValue;
                    const percentageChange = _.isNil(leftValue)
                        ? undefined
                        : getPercentageChangeV2(kpi?.actual, leftValue);
                    const absChange = _.isNil(leftValue) ? undefined : leftValue - kpi?.actual;

                    kpiObject[kpiItem?.['label']] = {
                        pre: kpiItem.pre || '',
                        post: kpiItem.post || '',
                        allowedDecimals: kpiItem.allowedDecimals,
                        iconType: kpiItem.iconType || '',
                        isEditable: isEditable,
                        key: kpi?.id, // dont change this
                        sortKey: `kpi_${kpi?.id}`,
                        input: inputValue ?? undefined, //converting null/undefined to undefined as isNaN(null) is false
                        actual: kpi?.actual ?? undefined,
                        output: outputValue ?? undefined,
                        displayValue: displayValue,
                        recommended: undefined,
                        perChange: percentageChange ?? undefined,
                        absChange: absChange ?? undefined,
                    };
                }
            });

            //dynamically adding dimensions
            const dimAttributes: any = {};
            item?.attributes_data?.forEach((attributeType: any) => {
                dimAttributes[attributeType['attribute_type']] = attributeType.attribute_name;
            });
            return {
                key: `${item?.attributes_data?.[0]?.attribute_name}-${index}-${item?.attributes_data?.[1]?.attribute_name}`,
                pk: item?.row_id, //primary key will be available for lowest level
                ...dimAttributes,
                attributeNames: Object.values(dimAttributes),
                isDeListed: item?.delisted,
                isCompetitorToFollow: item?.comp_follow,
                ...kpiObject,
            };
        });
        return result;
    } catch (error) {
        throw error;
    }
};
